<template>
    <div class="column" @click="$emit ('select', index)">
        <div class="card category">
            <header class="card-header">
                <p class="card-header-title">
                    <tr-text v-bind="props.label"
                        :tracker="tracker"
                        @edit-tr="$emit('edit-tr', $event)"
                    > </tr-text>
                </p>
                {{ translatedTrUnits }} / {{ totalTrUnits }}
            </header>
            <div class="card-image" v-if="props.image">
                <figure class="image is-128x128">
                    <img :src="props.image.val" :alt="props.model.val">
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
import TrText from "@/components/translation/TrText"
import { mapState }         from 'vuex'

export default {
    name: "TrObject",
    components: {TrText},
    props: ["props", "children", "t9n", "t9n_tags", "tag", "index", "tracker"],
    computed: {
        ...mapState ("translation", {
            targetLang:  state => state.targetLang,
            sourceLang:  state => state.sourceLang,
            languages:   state => state.languages,
        }),
        translatedTrUnits () {
            let translated = 0
            const trLang = this.languages [this.targetLang] [1]
            for (const key of this.t9n_tags) {
                if (key in trLang) translated += 1
            }
            return translated
        },
        totalTrUnits () {
            return this.t9n_tags.length
        }
    }
}
</script>

<style>

</style>